import { render, staticRenderFns } from "./SuppliersRanking.vue?vue&type=template&id=1b03c67e&scoped=true&"
import script from "./SuppliersRanking.vue?vue&type=script&lang=js&"
export * from "./SuppliersRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b03c67e",
  null
  
)

export default component.exports